import { render, staticRenderFns } from "./PortfolioOne.vue?vue&type=template&id=07c290b2&"
import script from "./PortfolioOne.vue?vue&type=script&lang=js&"
export * from "./PortfolioOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c290b2')) {
      api.createRecord('07c290b2', component.options)
    } else {
      api.reload('07c290b2', component.options)
    }
    module.hot.accept("./PortfolioOne.vue?vue&type=template&id=07c290b2&", function () {
      api.rerender('07c290b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/portfolio/PortfolioOne.vue"
export default component.exports